<template>
    <v-container fluid>
        <v-layout row wrap>
            <v-flex xs12 class="text-xs-center" mt-5>
                <h1>{{this.$t('qr_code_section_title')}}</h1>
                <qrcode :value="qr_link" :options="{ width: 200 }"></qrcode>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: "SubscriptionQrViewer",
        props: ['deviceData'],
        computed : {
            qr_link(){
                let subscription = this.deviceData.deviceName
                if(this.deviceData.subscriptionCode){
                    subscription += '?subscriptionCode=' + this.deviceData.subscriptionCode
                }
                return subscription
            }
        }
    }
</script>

<style scoped>
</style>

<i18n>
    {
        "en": {
            "qr_code_section_title": "Subscription QR code"
        },
        "es": {
            "qr_code_section_title": "Código QR de subscripción"
        }
    }
</i18n>